import { render, staticRenderFns } from "./taobaoTag.vue?vue&type=template&id=75960e24&scoped=true&"
import script from "./taobaoTag.vue?vue&type=script&lang=js&"
export * from "./taobaoTag.vue?vue&type=script&lang=js&"
import style0 from "./taobaoTag.vue?vue&type=style&index=0&id=75960e24&lang=scss&scoped=true&"
import style1 from "./taobaoTag.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75960e24",
  null
  
)

export default component.exports